import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { connectSideNav } from 'shared/hoc/withSideNav';
import connectRoutes from 'shared/hoc/withRoutes';
import {
  roleViewCheck, userCreateCheck, userEditCheck, userGroupViewCheck, userViewCheck,
} from 'shared/api/admin';
import { MODULES } from 'shared/constants';
import {
  createPath, permissionPath, rootPath, viewGroupPath, viewPath,
} from 'shared/routes/admin';
import UserSearch from './UserSearch';
import UserCreator from './UserCreator';
import User from './User';
import PermissionViewer from './PermissionViewer';
import UserGroup from './UserGroup';

const withSideNav = connectSideNav(MODULES.admin);

const withRoutes = connectRoutes([
  {
    RouteComponent: User,
    path: `${viewPath}/:routeId`,
    routeToTest: userEditCheck,
  },
  {
    RouteComponent: UserSearch,
    path: viewPath,
    text: 'Registered Users',
    routeToTest: userViewCheck,
  },
  {
    RouteComponent: UserCreator,
    path: createPath,
    text: 'Create Users',
    routeToTest: userCreateCheck,
  },
  {
    RouteComponent: UserGroup,
    path: viewGroupPath,
    text: 'User Groups',
    routeToTest: userGroupViewCheck,
  },
  {
    RouteComponent: PermissionViewer,
    path: permissionPath,
    text: 'Access Control',
    routeToTest: roleViewCheck,
  },
]);

/**
 * @param {Object} props
 * @param {Array<Object>} props.enabledRoutes
 */
function Admin(props) {
  const { enabledRoutes } = props;

  return (
    <Switch>
      {enabledRoutes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          component={route.RouteComponent}
        />
      ))}
    </Switch>
  );
}

export default {
  RouteComponent: withRoutes(withSideNav(Admin)),
  module: 'user',
  name: 'Admin',
  path: viewPath,
  rootPath,
  routeToTest: userEditCheck,
};
